import { combineReducers } from "redux";
import { reducer as getManifestacoesGeojson } from "./actions/getManifestacoesGeojson";
import { reducer as getTipoManifestacao } from "./actions/getTipoManifestacao";
import { reducer as criarManifestacao } from "./actions/criarManifestacao";
import { reducer as obterManifestacaoPorId } from "./actions/obterManifestacaoPorId";
import { reducer as adicionarMensagem } from "./actions/adicionarMensagem";
import { reducer as encerrarManifestacao } from "./actions/encerrarManifestacao";

export const manifestacoes = combineReducers({
  getManifestacoesGeojson,
  getTipoManifestacao,
  criarManifestacao,
  obterManifestacaoPorId,
  adicionarMensagem,
  encerrarManifestacao
});
